import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.less']
})
export class CancellationPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
